import React, { Button, Component, useState } from "react";
import Utils from "../../../utils/utils";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import WaitDialog from "../../../widgets/WaitDialog";

import GetCorsi from "../../../services/getCorsi";
import getStudenti from "../../../services/getStudentiForBilling";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import GestioneRateWidget from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import addPianoPagamentiCorsoStudenti from "../../../services/addPianoPagamentiCorsoStudenti";
import getRataStatus from "../../../services/getRataStatus";
import getCorsi from "../../../services/getCorsi";
import getPianiCorsoStudente from "../../../services/getPianiCorsoStudente";

export default class StudenteDetails extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {};
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentStudente = cookies.get("currentStudente", { path: "/" });
    this.corsi = await GetCorsi(username, token);

    this.studenti = await getStudenti(username, token);
    this.studente = this.studenti.find((s) => s.id == currentStudente);

    // Controllo se lo studente è stato trovato
    if (!this.studente) {
      console.error("Studente non trovato con ID:", currentStudente);
      alert("Errore: Studente non trovato. Verifica che lo studente esista.");
      return;
    }

    // Controllo se lo studente ha la proprietà corsi
    if (!this.studente.corsi) {
      console.warn("Lo studente non ha corsi associati");
      this.studente.corsi = ""; // Imposta una stringa vuota come fallback
    }

    var corsi = await getCorsi(username, token);
    this.listaCorsi = await getPianiCorsoStudente(
      username,
      token,
      currentStudente,
    );

    // Fallback se il backend restituisce undefined o null
    if (!this.listaCorsi || !Array.isArray(this.listaCorsi)) {
      console.warn("[StudenteDetails] listaCorsi non valida, uso array vuoto");
      this.listaCorsi = [];
    }

    Utils.parseCorsi(this.studente.corsi).forEach((corso) => {
      var c = this.corsi.find((temp) => temp.id == corso);
      if (c == undefined) return;
      if (this.listaCorsi.find((c) => c.id_corso == corso) != undefined) return;
      this.listaCorsi.push({
        id_corso: c.id,
        id_studente: this.studente.id,
        piano: {},
      });
    });

    this.corsiDetails = {};

    for (var c of this.listaCorsi) {
      var corsoId = c.id_corso;
      if (corsoId == "") continue;
      var corso = corsi.find((cc) => cc.id == corsoId);
      var pianoRateCorso = await getPianoPagamentiCorso(
        username,
        token,
        corsoId,
      );
      var pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(
        username,
        token,
        corsoId,
        this.studente.id,
      );
      var rateStatus = await getRataStatus(
        username,
        token,
        corsoId,
        this.studente.id,
      );
      // Determina il corso originale del piano rateale:
      // 1. Prima controlla nel piano personalizzato dello studente (pianoRateCorsoStudente)
      // 2. Poi controlla nella lista corsi dal backend (c)
      // 3. Fallback al corso corrente
      var corsoCambiatoDaPiano =
        pianoRateCorsoStudente && pianoRateCorsoStudente._corsoCambiato == 1;
      var corsoCambiatoDaLista = c.corso_cambiato == 1;
      var nomeCorsoOriginaleDaPiano =
        pianoRateCorsoStudente && pianoRateCorsoStudente._nomeCorsoOriginale;
      var nomeCorsoOriginaleDaLista = c.nome_corso_originale;
      var idCorsoOriginaleDaPiano =
        pianoRateCorsoStudente && pianoRateCorsoStudente._idCorsoOriginale;
      var idCorsoOriginaleDaLista = c.id_corso_originale;

      this.corsiDetails[corsoId] = {
        corso: corso,
        rateCorso: pianoRateCorso,
        rateCorsoStudente: pianoRateCorsoStudente,
        rateStatus: rateStatus,
        // Info sul cambio corso: priorità al piano dello studente, poi alla lista
        corsoCambiato: corsoCambiatoDaPiano || corsoCambiatoDaLista,
        nomeCorsoOriginale:
          nomeCorsoOriginaleDaPiano || nomeCorsoOriginaleDaLista || null,
        idCorsoOriginale:
          idCorsoOriginaleDaPiano || idCorsoOriginaleDaLista || null,
      };
    }

    this.setState({
      corsiDetails: this.corsiDetails,
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    const cookies = new Cookies();

    this.searchCols = ["nome", "cognome", "mail"];

    if (this.state.corsiDetails == undefined) return <div></div>;

    // Controllo se lo studente è definito
    if (!this.studente) {
      return (
        <div>
          <PageTitle title={"Errore - Studente non trovato"} />
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p>Errore: Studente non trovato o non selezionato.</p>
            <p>Torna alla lista degli studenti e riprova.</p>
          </div>
        </div>
      );
    }

    this.custom =
      this.pianoRateCorsoStudente != undefined &&
      this.pianoRateCorsoStudente != null;

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={
              "Rate di " + this.studente.nome + " " + this.studente.cognome
            }
          />

          <div
            style={{
              border: "1px solid #888",
              padding: "10px",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            <div>{this.studente.nome + " " + this.studente.cognome}</div>
          </div>
          {this.listaCorsi.map((c) => {
            var corsoId = c.id_corso;
            if (corsoId == "") return null;
            if (this.corsiDetails[corsoId].corso == undefined) return null;

            // Nome del corso originale del piano rateale (se cambiato corso)
            var corsoPianoOriginale =
              this.corsiDetails[corsoId].nomeCorsoOriginale ||
              this.corsiDetails[corsoId].corso.name;
            var pianoRateCorso = this.corsiDetails[corsoId].rateCorso;
            var pianoRateCorsoStudente = this.corsiDetails[corsoId]
              .rateCorsoStudente;

            // Usa il flag dal backend che controlla la tabella cambio_corso
            var haCambiatoCorso = this.corsiDetails[corsoId].corsoCambiato;

            // Nome del corso attuale (quello dove lo studente è ora)
            var corsoAttuale = this.corsiDetails[corsoId].corso.name;

            console.log(
              "[StudenteDetails] Studente ID:",
              this.studente.id,
              "| Corso attuale:",
              corsoAttuale,
              "(id:",
              corsoId,
              ")",
              "| Corso originale piano:",
              corsoPianoOriginale,
              "| Ha cambiato (backend):",
              haCambiatoCorso,
              "| ID originale:",
              this.corsiDetails[corsoId].idCorsoOriginale,
              "| Raw listaCorsi item:",
              JSON.stringify(
                this.listaCorsi.find((l) => l.id_corso == corsoId),
              ),
            );

            // Se ha cambiato corso, mostra il corso ORIGINALE del piano come titolo principale
            // altrimenti mostra il corso corrente
            var titoloCorso =
              haCambiatoCorso &&
              corsoPianoOriginale &&
              corsoPianoOriginale !== corsoAttuale
                ? corsoPianoOriginale
                : corsoAttuale;

            return (
              <div key={corsoId}>
                <br />
                <div style={{ fontSize: 20, fontWeight: "bold" }}>
                  {titoloCorso}
                  {haCambiatoCorso &&
                    corsoPianoOriginale &&
                    corsoPianoOriginale !== corsoAttuale && (
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: "normal",
                          color: "#28a745",
                          marginLeft: 10,
                          backgroundColor: "#e8f5e9",
                          padding: "2px 8px",
                          borderRadius: "4px",
                        }}
                      >
                        Corso attuale: {corsoAttuale}
                      </span>
                    )}{" "}
                  -{" "}
                  <i
                    style={{
                      fontSize: 15,
                      cursor: "pointer",
                      color: "#ff3333",
                    }}
                    onClick={() => {
                      cookies.set("currentStudent", this.studente.id, {
                        path: "/",
                      });
                      cookies.set("currentCourse", corsoId, { path: "/" });
                      window.location.href = "/#/app/billing/editStudente";
                    }}
                  >
                    Modifica
                  </i>
                </div>
                <GestioneRateWidget
                  piano={
                    pianoRateCorsoStudente != undefined
                      ? pianoRateCorsoStudente
                      : pianoRateCorso
                  }
                  custom={pianoRateCorsoStudente != undefined}
                  isStudent={true}
                  compactMode={true}
                  studentObj={this.studente}
                  corso={this.corsiDetails[corsoId].corso}
                  onSalva={async (costo, rate) => {
                    // Preserva i metadata esistenti (incluso corso_origine per tracciare il corso originale)
                    var existingMetadata =
                      pianoRateCorsoStudente && pianoRateCorsoStudente.metadata
                        ? pianoRateCorsoStudente.metadata
                        : null;

                    var json = {
                      costo: costo,
                      rate: rate,
                    };

                    // Se esistono metadata (es. corso_origine), li preserva
                    if (existingMetadata) {
                      json.metadata = existingMetadata;
                    }

                    if (this.custom == false) {
                      if (window.confirm("Passare al piano custom?") == false)
                        return;
                    }

                    const cookies = new Cookies();
                    const username = cookies.get("username", { path: "/" });
                    const token = cookies.get("token", { path: "/" });
                    let res = await addPianoPagamentiCorsoStudenti(
                      username,
                      token,
                      corsoId,
                      this.studente.id,
                      JSON.stringify(json),
                    );
                    if (res.result === "KO") {
                      alert(
                        "Si è verificato un errore durante il salvataggio dei dati",
                      );
                      return;
                    }

                    this.custom = true;
                    alert("Salvataggio effettuato");
                  }}
                />
              </div>
            );
          })}

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </div>
    );
  }
}
